/* --------------------------------------------------------------------------------------
   ssoCallback.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const cliossoComponent = {
  template:`
    <auto-post-form options="vm.xeroxSsoLoginInfo" ng-if="vm.xeroxSsoLoginInfo"></auto-post-form>
      <activity
        display="vm.loading"
        label="{{ 'LOADING_CLIO' | translate }}"
        on-close="vm.loadingClosed()"
      ></activity>
    `
    ,
  controllerAs: "vm",
  controller: class cliossoCtrl {
    /* @ngInject */
    constructor(
      commonService,
      ssoClientService,
      xeroxSsoService,
      persistService,
      sessionService,
      apiClientService,
      $state
    ) {
      this.commonService = commonService;
      this.ssoClientService = ssoClientService;
      this.xeroxSsoService = xeroxSsoService;
      this.persistService = persistService;
      this.sessionService = sessionService;
      this.apiClientService = apiClientService;
      this.$state = $state;
    }
    async $onInit() {
      const accountCountry = this.persistService.getObject("accountCountry");
      this.apiClientService.setTokenAuthHeader(null, accountCountry)
      const code = new URLSearchParams(window.location.search).get("code");
      const tokenData = await this.ssoClientService.getToken(code);
      this.ssoClientService.setTokenLocally(tokenData);
      this.authSessionData =
        await this.sessionService.getDeviceAuthSessionData();

      if (this.authSessionData) {
        this.xeroxSsoLoginInfo = await this.xeroxSsoService.getSignupModel(
          tokenData
        );
        this.commonService.updateView();
      } else {
        setTimeout(() => {
          this.waitAndStart(tokenData, accountCountry)
        }, 1000);
      }
    }
    waitAndStart(tokenData, accountCountry) {
      const loadingTime = location.port? 0 : 4000
      this.loading = !!loadingTime
      this.commonService.updateView()
      this.tokenData = tokenData;
      this.apiClientService.setTokenAuthHeader(
        tokenData.access_token,
        accountCountry
      );
      if (!loadingTime)
       this.$state.go("main")
      else 
        setTimeout(() => {
          this.loading = false   
          this.commonService.updateView()
        }, loadingTime);
    }
    loadingClosed() {
      this.$state.go("main");    
    }
  },
};
 


// WEBPACK FOOTER //
// ./src/app/components/cliosso.component.js